let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import styled from 'foundations-theming-specialty/utils';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAIN_CONTENT_ID = 'portal-main-content';
const SkipLink = styled.a.withConfig({
  displayName: "SkipToMainContent__SkipLink"
})(({
  theme
}) => ({
  position: 'absolute',
  insetBlockStart: theme.space['400'],
  insetInlineStart: theme.space['400'],
  // Above the header and side nav
  zIndex: 1112,
  paddingBlock: theme.space['200'],
  paddingInline: theme.space['400'],
  borderRadius: theme.borderRadius['100'],
  border: `1px solid ${theme.color['border-core-default']}`,
  backgroundColor: theme.color['fill-surface-default'],
  color: theme.color['text-core-default'],
  '&:not(:focus)': {
    clipPath: 'inset(50%)',
    blockSize: '1px',
    inlineSize: '1px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: 0,
    border: 0
  }
}));
const MainContentFocusStyles = createGlobalStyle(_t || (_t = _`
  #${0}:focus {
    outline: none;
  }
`), MAIN_CONTENT_ID);
export function SkipToMainContent() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MainContentFocusStyles, {}), /*#__PURE__*/_jsx(SkipLink, {
      href: `#${MAIN_CONTENT_ID}`,
      onClick: event => {
        var _document$getElementB;
        event.preventDefault();
        (_document$getElementB = document.getElementById(MAIN_CONTENT_ID)) === null || _document$getElementB === void 0 || _document$getElementB.focus();
      },
      children: unescapedText('app.skipToMainContent')
    })]
  });
}